import Image from 'next/image'
import styled, { keyframes } from 'styled-components'

import { FlexContainer } from '@/components'

export const FlexContainerHero = styled(FlexContainer)`
  height: 100vh;
  padding: 0;
  max-width: 1170px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .container-hero {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0;
    gap: 42px;
  }

  @media (max-width: 1180px) {
    padding: 0 16px !important;
  }
`
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .heading {
    //isSmallDesktop
    @media (max-width: 800px) {
      font-size: ${({ theme }) => theme.fontSizes.h3};
    }
    //isBiggerMobile
    @media (max-width: 700px) {
      font-size: ${({ theme }) => theme.fontSizes.h5};
    }
  }
`

const animateGlow = keyframes`
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
`
export const ImageWrapper = styled.div`
  position: relative;
  z-index: 1;
  transition: all 0.1s ease-in-out;

  &::before {
    content: '';
    display: block;
    z-index: -1;

    position: absolute;
    top: 5px;
    right: 0px;

    width: 320px;
    height: 320px;

    animation: ${animateGlow} 7s ease-in-out infinite;
    background: linear-gradient(270deg, #08eddc, #09a8fa);
    background-size: 200% 200%;

    will-change: transform; // pre-optimizes for the blur filter
    filter: blur(166px);

    @media (max-width: 700px) {
      width: 120px;
      height: 120px;
      right: 0px;
      top: 0px;
      filter: blur(100px);
      background-size: 300% 300%;
    }
  }
`

export const NhImage = styled(Image)`
  width: 100%;
  height: 100%;

  @media (min-width: 701px) {
    min-height: 300px;
  }

  @media (max-width: 700px) {
    max-height: 122px;
  }

  @media (min-width: 700px) and (max-height: 750px) {
    width: 80%;
  }
  @media (min-width: 700px) and (max-height: 650px) {
    width: 60%;
  }
`
